import { db, fun } from '@/config'
import router from '@/router'
import { eventag } from '@/utils'
import * as VueAnalytics from 'vue-analytics'

const verifyReceipt = fun.httpsCallable('verifyReceipt')

const usersRef = db.collection('users')
const usersPrivacyRef = db.collection('users_privacy')
const programRef = db.collection('programs')
const watchingRef = db.collection('users_videos_last_times')

export default {
  strict: true,
  state: {
    userData: null,
    myList: null,
    watching: null
  },
  mutations: {
    userData (state, payload) {
      console.log({ userData: payload })
      state.userData = payload
    },
    myList (state, payload) {
      state.myList = (payload || []).filter(Boolean)
    },
    watching (state, payload) {
      state.watching = (payload || []).filter(Boolean)
    }
  },
  actions: {
    async getUserData ({ commit }, user) {
      if (!user) return commit('userData', null)
      return new Promise((resolve, reject) => {
        usersRef.doc(user.uid).onSnapshot((doc) => {
          // const data = { id: doc.id, ...doc.data() }
          commit('userData', { id: doc.id, ...doc.data() })
          resolve()
        })
      })
    },
    async myList ({ commit }, user) {
      if (!user) return commit('myList', null)
      return usersRef.doc(user.uid).collection('programs').onSnapshot(async (snap) => {
        const list = snap.docs.map(async (doc) => {
          const programRef = await doc.data().ref.get()
          if (programRef.exists) {
            const program = programRef.data()
            const data = { id: doc.id, ...program }
            return data
          } else {
            console.log({doc: doc.ref})
            doc.ref.delete()
          }
        })
        return commit('myList', await Promise.all(list))
      })
    },
    async getWatching ({ commit }, user) {
      if (!user) return commit('watching', null)
      return watchingRef.doc(user.uid).collection('videos').onSnapshot(async (snap) => {
        const list = snap.docs.map(async (doc) => {
          console.log('DOCID', doc.id)
          const data = { slug: doc.id, ...doc.data() }
          console.log('DATA..', data)
          const $programRef = await programRef.doc(doc.id).get()
          if ($programRef.exists) {
            const program = $programRef.data()
            return { ...program, ...data }
          } else {
            doc.ref.delete()
            return null
          }
        })
        return commit('watching', await Promise.all(list))
      })
    },
    addMyList({ commit, dispatch, getters }, payload) {
      const user = getters.userData
      const membership = getters.membership
      if (!user) {
        commit('myList', null)
        dispatch('requireLogin', 'addMyList')
        return false
      }
      if (!membership) {
        return dispatch('requireSubscription')
      }
      eventag({
        eventCategory: 'views',
        eventAction: 'addMyList',
        eventLabel: payload.slug,
        value: (getters.user || {}).id
      }, this)
      return usersRef.doc(user.id).collection('programs').doc(payload.id).set({
        ref: db.doc(`programs/${payload.id}`)
      })
    },
    removeMyList ({ commit, state, getters, dispatch }, payload) {
      const user = state.userData
      if (!user) {
        commit('myList', null)
        dispatch('requireLogin', 'removeMyList')
        return false
      }
      eventag({
        eventCategory: 'views',
        eventAction: 'removeMyList',
        eventLabel: payload.slug,
        value: (getters.user || {}).id
      }, this)
      return usersRef.doc(user.id).collection('programs').doc(payload.id).delete()
    },
    updateUser ({ state }, { id, ...payload }) {
      return usersRef.doc(id).set(payload, { merge: true })
    },
    updateUserPrivacy ({ state }, { id, ...payload }) {
      return usersPrivacyRef.doc(id).set(payload, { merge: true })
    },
    requireSubscription () {
      const from = router.currentRoute.path.length > 2 ? router.currentRoute.path : ''
      router.push({ name: 'Subscription', query: { from } })
    },
    async checkSubscription ({ getters }) {
      return true
      if (getters.source === 'iOS inApp' && getters.membership) {
        const now = Date.now()
        const found = getters.lastest.find(l => {
          return now < Number(l.expires_date_ms)
        })
        if (found) return 'active'
        else {
          await verifyReceipt()
          return 'pending'
        }
      }
      return getters.membership && getters.userData.membership.status
    },
    checkActiveUser ({ getters }) {
      return new Promise(async (resolve) => {
        if (!getters.user || !getters.user.uid) {
          resolve(false)
          return
        }
        const doc = await db.collection('active_users')
        .doc(getters.user.uid)
        .get()

        if (doc.exists) {
          const lastPlay = doc.data().lastPlay
          console.log('lastPlay: ', lastPlay)
          if (lastPlay) {
            const now = new Date().getTime()
            if ((now - lastPlay) < 300000) { // 5 minutes 
              resolve(true)
              return
            }
          }
        }
        resolve(false)
      })
    },
  },
  getters: {
    userData: (state) => (state.userData),
    lastest: (state) => (state.userData.lastest || []),
    pending: (state) => (state.userData && state.userData.membership && state.userData.membership.status.toLowerCase().includes('pending')),
    inactive: (state) => (state.userData && state.userData.membership && state.userData.membership.status.toLowerCase().includes('inactive')),
    membership: (state) => (state.userData && state.userData.membership && state.userData.membership.status === 'active'),
    canceled: (state) => (state.userData && state.userData.membership && state.userData.membership.status === 'canceled'),
    plan: (state) => (state.userData && state.userData.membership && state.userData.membership.plan),
    source: (state) => (state.userData && state.userData.membership && state.userData.membership.source),
    subscription: (state) => (state.userData && state.userData.membership && state.userData.membership.subscription),
    subscriptionId: (state) => (state.userData && state.userData.membership && state.userData.membership.subscriptionId),
    myList: (state) => (state.myList),
    watching: (state) => (state.watching),
    likes: (state) => ((state.userData || {}).likes || {}),
    admin: (state) => ((state.userData || {}).roles || {}).admin,
    editor: (state) => ((state.userData || {}).roles || {}).editor
  }
}
